import React from "react";
import QrReader from "react-qr-reader";
import { Modal } from "antd";

export const QRCodeScanner = ({ isVisible, onClose, onScan, onError }) => {
  const handleScan = (data) => {
    if (data) onScan(data);
  };

  const handleError = (err) => onError(err);

  return (
    <Modal className="qrCodeScanner" visible={isVisible} footer={null} onCancel={onClose} closable={false}>
      <QrReader onError={handleError} onScan={handleScan} className="scanner" />
    </Modal>
  );
};
